import React = require("react");
import Select from "react-select";
import Slider, { Settings } from "react-slick";
import { JumboKiosk } from "../../Kiosk/JumboKiosk";
import { Link } from "../../library/link";
import { Loader } from "../../loader";
import { scrollAdviceIntoView } from "../Advice/Advice";
import { InspirationBaseSelector, inspirationLabelsKiosk } from "../Shared/InspirationBaseSelector";
import { jumboText, contentTexts } from "../Shared/InspirationUtils";
import { BookBasedInspirationLayoutProps } from "./BookBasedInspirationState";
import { pushBookBasedInspirationAction } from "../../datalayer";
import { SearchOn } from "../../../../custom_api/collection/types";
import { customSelectStyles, customSelectTheme } from "../Shared/AsyncSelectStyles";
import { ready } from "../../../../custom_api/api_utils";

export const BookBasedInspirationKioskLayout = (props: BookBasedInspirationLayoutProps) => {
  const { prompts, routePath, searchResults, searchQuery, updateSearchQuery, pickBook } = props
  let timeout

  const handleBeforeChange = () => {
    const sliderElement = document.querySelector(".slick-slider")
    if (sliderElement) {
      sliderElement.classList.remove("interaction-active")
      clearTimeout(timeout)
    }

    timeout = setTimeout(() =>
      sliderElement && sliderElement.classList.add("interaction-active"), 5000)
  }

  const handleAfterChange = index => {
    const sliderElement = document.querySelector(".slick-slider")
    index ? sliderElement?.classList.add('highlighted') : sliderElement?.classList.remove('highlighted')
  }

  return (
    <div className="inspiration-page ip ip--kiosk ip--book-based-inspiration" key="BookBasedInspirationLayout">
      <JumboKiosk {...jumboText.book} size="large" />

      <div className="ip__content slider__line">
        {prompts.kind != 'loaded' ? <Loader /> :
          <>
            <div className="layout layout--sc-column">
              <div className="layout__sidebar">
              <div className="layout__header ip__header--bookslider">
                <h2 className="layout__title layout__title--center">{contentTexts.book.selectionPrompt}</h2>
              </div>
                <Slider {...sliderProps} beforeChange={handleBeforeChange} afterChange={handleAfterChange}>
                  {prompts.value.map(b => {
                    const titleAndAuthor = `${b.title} - ${b.author}`
                    return <div key={`prompt-${b.isbn}`} className={`bookslider-item`}>
                      <Link
                        className="bookcover bookcover--large"
                        url={`/${routePath}/boek/${b.isbn}`}
                        title={titleAndAuthor}
                        handle={() => {
                          pushBookBasedInspirationAction("Klik op boek suggestie", titleAndAuthor);
                          scrollAdviceIntoView();
                        }}
                      >
                        <div className="bookcover__inner">
                          <img className="bookcover__image" src={`${b.cover}size=195`} srcSet={`${b.cover}size=195 1x, ${b.cover}size=340 2x`} alt={titleAndAuthor} loading="lazy" width="195" height="310" />
                        </div>
                      </Link>
                    </div>
                  })}
                </Slider>
                <div className="searchbar--kiosk">
                  <div className="searchbar--kiosk__inner">
                    <h2 className="searchbar--kiosk__title">{contentTexts.book.searchTitle}</h2>
                    <div className="searchbar--kiosk__input">
                      <Select<SearchOn>
                        className="searchbar__select react-select"
                        classNamePrefix="react-select"
                        placeholder={contentTexts.book.searchPlaceholder}
                        theme={(theme) => customSelectTheme(theme)}
                        noOptionsMessage={() => 'Geen suggesties gevonden.'}
                        isClearable={true}
                        styles={customSelectStyles}
                        onInputChange={updateSearchQuery}
                        onChange={pickBook}
                        inputValue={searchQuery}
                        options={ready(searchResults) ? searchResults.value : []}
                        onMenuOpen={ () => {} }
                        onMenuClose={ () => {} }
                        value={undefined}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      </div>
      <InspirationBaseSelector activeBase="book" routePath={routePath} labels={inspirationLabelsKiosk} />
    </div>)
}

const sliderProps: Settings = {
  accessibility: true,
  className: 'interaction-active',
  dots: false,
  arrows: false,
  infinite: false,
  variableWidth: true,
  speed: 500,
  swipeToSlide: true,
  draggable: true,
  slidesToShow: 4,
  swipe: true,
}
